import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../main/main.styles';
import { mixinScreen } from '../../styles';

export const BuyerDashboardStyles = css`
  ${MainStyles}
  :host {
    ${mixinScreen('flex')}

    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .dashboard-grid {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 12px;
  }

  .dashboard-grid .card-group-2 {
    display: grid;
    grid-gap: 12px;
    grid-template-columns: 1fr 1.3fr;
    grid-auto-rows: minmax(365px, auto);
    grid-column: 1/3;
  }

  rfq-modal {
    display: contents;
  }

  .market-index-title {
    height: 36px;
    padding: 2px 4px;
    font-family: 'Roboto-Medium', 'Roboto Medium', 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: var(--white-smoke);
    text-align: left;
    line-height: 15px;
  }

  .no-padding-card {
    padding: 0;
  }

  cancel-modal {
    display: contents;
  }

  .watchlist-card {
    overflow: hidden;
  }
`;
